import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Trash(props) {
  const { height, width, backgroundColor, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill={backgroundColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M11.8125 3.0625H2.1875" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.6875 5.6875V9.1875" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.3125 5.6875V9.1875" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.9375 3.0625V11.375C10.9375 11.491 10.8914 11.6023 10.8094 11.6844C10.7273 11.7664 10.616 11.8125 10.5 11.8125H3.5C3.38397 11.8125 3.27269 11.7664 3.19064 11.6844C3.10859 11.6023 3.0625 11.491 3.0625 11.375V3.0625"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1875 3.0625V2.1875C9.1875 1.95544 9.09531 1.73288 8.93122 1.56878C8.76712 1.40469 8.54456 1.3125 8.3125 1.3125H5.6875C5.45544 1.3125 5.23288 1.40469 5.06878 1.56878C4.90469 1.73288 4.8125 1.95544 4.8125 2.1875V3.0625"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Trash.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Trash.defaultProps = {
  height: 14,
  width: 14,
  backgroundColor: 'none',
  iconColor: colors.colorRed
};

export default Trash;
